import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Invalida as queries de listagem/detalhe de freelancers após uma mutação
 * (editar, avaliar, tag, status, merge). Substitui o antigo
 * invalidateCache/updateFreelancerInCache/clearCache do FreelancersCacheContext,
 * que foi aposentado — a listagem agora é server-side (RPC search_freelancers).
 */
export function useFreelancersInvalidate() {
  const queryClient = useQueryClient();
  return useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ["freelancers-search"] });
    queryClient.invalidateQueries({ queryKey: ["freelancers-total-count"] });
    queryClient.invalidateQueries({ queryKey: ["freelancer"] });
    queryClient.invalidateQueries({ queryKey: ["freelancer-avaliacao"] });
  }, [queryClient]);
}
